import type { ObservationLite } from "@/entities/observation";
import type { UseListOptions } from "@/hooks/queries";

import { useList } from "@/hooks/queries";

export const useGetObservations = (
  options?: UseListOptions<ObservationLite>
) => {
  const { data, ...queryResult } = useList<ObservationLite>(
    "observations",
    options
  );

  return {
    observations: data?.data ?? [],
    ...queryResult,
  };
};
